import axios from '../config/axios';
import { notification } from 'antd';
import {getResponseHandler,header} from './commonService'

const order = {
     
    getOrderList : async (data={}) => {
        try{
            let rowData;
            rowData = await axios.get('/order/',header(data,1))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    }, 
    saveOrder : async (data={}) =>{
        try{
            const rowData = await axios.post('/order',header(data,1))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    },
    myOrders : async (data={}) =>{
        try{
            const rowData = await axios.post('/order/myorders',header(data,1))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    },
    OrderDetails : async (id) =>{
        try{
            let rowData;
            rowData = await axios.get('/order/'+id,header())
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    },
    changeStatus : async (data = {}) => {
        try{
            const rowData = await axios.post('/order/statusChange',header(data))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
    },
    qPayPayment : async (data = {}) => {
        try{
            const rowData = await axios.post('/payment/creatPayment',header(data))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
    }, 
    uploadPayment : async (data = {}) => {
        try{
            const rowData = await axios.post('/order/updatePayment',header(data))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
    },
    getPaymentUpload : async (data={}) =>{
        try{
            let rowData;
            rowData = await axios.get('/uploadPayment',header(data))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    },
    paymentVerify : async (data = {}) => {
        try{
            const rowData = await axios.post('/order/paymentVerify',header(data))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
    },

    downloadInvoice : async (data = {}) => {
        try{
          
            const rowData = await axios.post('/order/downloadInvoice',header(data))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
    },
    getOrderLog : async (data={}) =>{
        try{
            const rowData = await axios.post('/order/getOrderLog',header(data,1))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    },

}


export default order
